var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    width: 250,
    height: 250,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    rx: 58,
    fill: "#1F8BFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.00 30.00) scale(1.9000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 24,
    fill: "#1773D6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 32,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 17,
    strokeLinecap: "round",
    strokeDasharray: "158 43",
    transform: "rotate(-25 50 50)"
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(50 50) scale(0.8) translate(-50 -50)",
    points: "53,28 37,55 49,55 45,74 63,45 51,45",
    fill: "#FFD23F",
    stroke: "#FFD23F",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFD23F",
    strokeWidth: 5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 57.7,
    y1: 6.5,
    x2: 59.4,
    y2: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.4,
    y1: 12.4,
    x2: 77.8,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.5,
    y1: 22.3,
    x2: 90,
    y2: 19.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.7b040ce50aa40a970c9ad7d79c95bb19.svg";
export { ForwardRef as ReactComponent };